import React, { useState, useEffect, useContext } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';

import { DromoUploader, getTranslatedText, AppContext } from '@nile/components';
import Loader from '@nile/mangifera/src/Components/Ticket/TicketCount';

import {
  getSiteImportFields,
  getQuery,
  callQuery,
  shapeOptions
} from '../Fields/siteFields';
import { intlConverter } from '../utils/helpers';

const SiteUploader = ({
  onResults,
  onCancel,
  validationProps = {},
  fields: propFields,
  userToken,
  intl,
  activator
}) => {
  const appContext = useContext(AppContext);
  const { currentProduct } = appContext;
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [fields, setFields] = useState([]);

  useEffect(() => {
    if (!propFields) {
      setLoading(true);
      const initFields = [...getSiteImportFields(currentProduct)];

      const selectFields = getSiteImportFields(currentProduct)?.reduce(
        (acc, field, idx) => {
          if (field.type === 'select')
            acc[idx] = getQuery(field.key)
              ? callQuery(field.key)
              : field.selectOptions;
          return acc;
        },
        {}
      );

      const promises = Object.values(selectFields);
      Promise.all(promises)
        .then((options) => {
          options.forEach((set, idx) => {
            const indexToModify = Object.keys(selectFields)[idx];
            initFields[indexToModify].selectOptions = shapeOptions(
              initFields[indexToModify].key,
              set
            );
          });
          const convertedFields = intlConverter(intl, initFields);
          setFields([...convertedFields]);
          setLoading(false);
        })
        .catch((e) => {
          setLoading(false);
          setError(true);
          console.log(e);
        });
    }
  }, []);

  if (loading) return <Loader loading />;

  if (error) return null;

  return (
    <DromoUploader
      settings={{
        importIdentifier: 'CLIENT_SITE',
        title: getTranslatedText(intl, 'dromo.site.import.title')
      }}
      fields={propFields || fields}
      rowHooks={[(row) => row]}
      columnHooks={[(column) => column]}
      onResults={(response, metadata) => {
        setResults(response);
        if (onResults) onResults();
      }}
      onCancel={() => {
        if (onCancel) onCancel();
      }}
      activator={
        activator || (
          <div className="flex center actionListItemPadding ptr">
            <div className="mr-10 flex center">
              <SVGIcon name="Site" />
            </div>
            <FormattedMessage id="migrate.data.site.title" />
          </div>
        )
      }
      userToken={userToken}
      backendSync
    />
  );
};

export default injectIntl(SiteUploader);
